import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentService } from '../environment/environment.service';
import { lastValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ServerTimeService {
  private http = inject(HttpClient);
  private environmentService = inject(EnvironmentService);

  public resourceUrl: string;

  constructor() {
    this.resourceUrl = this.environmentService.getApiUrl() + 'api/';
  }

  async getServerTime(): Promise<{ servertime: string }> {
    return lastValueFrom(this.http.get<{ servertime: string }>(this.resourceUrl + 'servertime'));
  }
}
